const handleBrandIdsParameter = () => {
  if (!process.env.GATSBY_BRAND_ID) return 'brandId='

  const brandIds = process.env.GATSBY_BRAND_ID
  const brandIdsList = brandIds.split(',') 
  const parameter = brandIdsList.length > 1 ? `brandIds=${brandIds}` : `brandId=${brandIdsList[0]}`

  return parameter
}


module.exports = { handleBrandIdsParameter }